import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';
import { historyOrReload } from 'utils/helpers';
import { useCurrentBookingState } from 'utils/hooks/use_current_booking_state';
import { discardBooking } from 'redux/actions/booking';
import { getCurrentBooking } from 'redux/selectors/current_booking';

const ContinueEditing = ({ reload = false }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const currentBooking = useSelector(getCurrentBooking);
  const { isEditing } = useCurrentBookingState();

  const onEditMyBooking = () => {
    if (history && history.length > 1 && !reload) {
      history.goBack();
    } else {
      historyOrReload(history, `/bookings/${currentBooking.id}`, reload);
    }
  };

  const onStartNewBooking = () => {
    dispatch(discardBooking({ clearFerryGrouping: true })).then(() => {
      historyOrReload(history, '/bookings/', reload);
    });
  };

  const onCheckout = () => {
    historyOrReload(history, '/bookings/checkout', reload);
  };

  return (
    <Modal
      show={isEditing}
      className="border-0"
      backdropClassName="cover-off-canvas"
      centered
    >
      <div className="p-3">
        <Modal.Header className="pb-3">
          <Modal.Title>You&apos;re currently editing a booking</Modal.Title>
        </Modal.Header>
        <Modal.Body className="content px-0 d-flex justify-content-center flex-column">
          <div>
            <p>
              You&apos;re current editing booking{' '}
              <strong>{currentBooking.reference}</strong>.
              <br />
              How do you want to proceed?
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="p-0 border-0 d-flex flex-column">
          <div className="d-flex flex-column gap-2 w-100">
            <Button onClick={onEditMyBooking}>
              Return to editing my booking
            </Button>
            <Button variant="outline-primary" onClick={onCheckout}>
              Go to checkout
            </Button>
            <Button variant="outline-danger" onClick={onStartNewBooking}>
              Exit and start a new booking
            </Button>
          </div>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

ContinueEditing.propTypes = {
  reload: PropTypes.bool,
};

export default ContinueEditing;
